/**
 * QA Accordion (Bootstrap 5)
 *
 * HTML API:
 *  - data-style="string"           (default: "default")
 *  - data-open-first="false"       (default: true)
 *
 * @param {string} selector
 */
export function qaAccordion(selector = ".accordion-qa") {
	const wraps = document.querySelectorAll(selector);

	wraps.forEach((wrap, wrapIndex) => {
		// style (зарезервировано)
		const style = wrap.getAttribute("data-style") || "default";
		void style;

		// openFirst: default true
		let openFirst = true;
		if (wrap.getAttribute("data-open-first") === "false") {
			openFirst = false;
		}

		const itemsContainer = wrap.querySelector(".accordion-qa-items");
		if (!itemsContainer) return;

		const accordionId = `qa-accordion-${wrapIndex + 1}`;
		itemsContainer.id = accordionId;

		const items = itemsContainer.querySelectorAll(".accordion-qa-item");

		items.forEach((item, itemIndex) => {
			const question = item.querySelector(".accordion-qa-item-question");
			const button = item.querySelector(".accordion-qa-item-question-button");
			const answer = item.querySelector(".accordion-qa-item-answer");

			if (!question || !button || !answer) return;

			const index = itemIndex + 1;
			const headingId = `qa-heading-${wrapIndex + 1}-${index}`;
			const collapseId = `qa-collapse-${wrapIndex + 1}-${index}`;

			// ids
			question.id = headingId;
			answer.id = collapseId;

			// button attrs
			button.type = "button";
			button.dataset.bsToggle = "collapse";
			button.dataset.bsTarget = `#${collapseId}`;
			button.setAttribute("aria-controls", collapseId);

			// collapse attrs
			answer.classList.add("collapse");
			answer.setAttribute("aria-labelledby", headingId);
			answer.dataset.bsParent = `#${accordionId}`;

			// initial state
			const isOpen = openFirst && itemIndex === 0;

			button.setAttribute("aria-expanded", String(isOpen));
			button.classList.toggle("collapsed", !isOpen);

			answer.classList.toggle("show", isOpen);
			item.classList.toggle("hs-show", isOpen);

			// sync state on Bootstrap events
			answer.addEventListener("shown.bs.collapse", () => {
				button.classList.remove("collapsed");
				button.setAttribute("aria-expanded", "true");
				item.classList.add("hs-show");
			});

			answer.addEventListener("hidden.bs.collapse", () => {
				button.classList.add("collapsed");
				button.setAttribute("aria-expanded", "false");
				item.classList.remove("hs-show");
			});
		});
	});
}
